'use client'

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectSnackbarState } from 'store/partials/snackbar/snackbarSelectors'
import { closeSnackbar } from 'store/partials/snackbar/snackbarSlice'

import { SnackbarWrapper } from './styles'

export const Snackbar = (): JSX.Element | null => {
  const dispatch = useDispatch()
  const { message, visible, isError } = useSelector(selectSnackbarState)

  useEffect(() => {
    let timeout: null | ReturnType<typeof setTimeout> = null
    if (visible) {
      timeout = setTimeout(() => {
        dispatch(closeSnackbar())
      }, 3500)
    }

    return () => {
      timeout && clearTimeout(timeout)
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [visible])

  if (visible) {
    return <SnackbarWrapper isError={isError}>{message}</SnackbarWrapper>
  }

  return null
}
